/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceAgreementModificationRequest
 */
export interface ServiceAgreementModificationRequest {
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementModificationRequest
     */
    productAttributeId: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceAgreementModificationRequest
     */
    updatedForm: string;
    /**
     * 
     * @type {boolean}
     * @memberof ServiceAgreementModificationRequest
     */
    forceRepapering?: boolean;
}

/**
 * Check if a given object implements the ServiceAgreementModificationRequest interface.
 */
export function instanceOfServiceAgreementModificationRequest(value: object): value is ServiceAgreementModificationRequest {
    if (!('productAttributeId' in value) || value['productAttributeId'] === undefined) return false;
    if (!('updatedForm' in value) || value['updatedForm'] === undefined) return false;
    return true;
}

export function ServiceAgreementModificationRequestFromJSON(json: any): ServiceAgreementModificationRequest {
    return ServiceAgreementModificationRequestFromJSONTyped(json, false);
}

export function ServiceAgreementModificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceAgreementModificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'productAttributeId': json['productAttributeId'],
        'updatedForm': json['updatedForm'],
        'forceRepapering': json['forceRepapering'] == null ? undefined : json['forceRepapering'],
    };
}

export function ServiceAgreementModificationRequestToJSON(json: any): ServiceAgreementModificationRequest {
    return ServiceAgreementModificationRequestToJSONTyped(json, false);
}

export function ServiceAgreementModificationRequestToJSONTyped(value?: ServiceAgreementModificationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'productAttributeId': value['productAttributeId'],
        'updatedForm': value['updatedForm'],
        'forceRepapering': value['forceRepapering'],
    };
}

